import { Link, Typography } from "@vp/swan"
import React from "react"

const SubCategoryLinkList = props => {
  return (
    <ul className="link-list">
      {props.subCategoryChildren.map((child, indexChild) => {
        return (
          <li key={`subCategory_${indexChild}`}>
            <Typography fontSize={"small"}>
              <Link
                data-fidoprefetchhint="HOVER"
                href={child.url}
              >
                {child.name}
              </Link>
            </Typography>
          </li>
        )
      })}
    </ul>
  )
}

export default SubCategoryLinkList
